import React, {useState} from 'react';
import {AddShoppingCart} from '@mui/icons-material';
import {CircularProgress} from '@mui/material';
import {toast} from 'react-toastify';
import {buildWithoutDeal} from '../domain/ProductSelection.model';
import {fulfillPendingOrder} from '../infrastructure/pendingOrderApi';
import {useCartContext} from '../../cart/context/CartContext';
import {useComercialContext} from '../../comercial/ComercialContext';

/**
 * Añade al carrito un pendiente que ya tiene stock, con las unidades que
 * quedaban pendientes, y lo marca como servido.
 *
 * @param {{
 *     pendingOrder: PendingOrder,
 *     onAdded?: (code: string) => void,
 *     onFailed?: () => void,
 * }} props
 */
export const AddRestockedToCartButton = ({pendingOrder, onAdded, onFailed}) => {
    const [loading, setLoading] = useState(false);
    const {addProduct} = useCartContext();
    const {actingAsCliente} = useComercialContext();

    const {product, pendingQuantity} = pendingOrder;

    const handleClick = async (event) => {
        event.stopPropagation();
        setLoading(true);
        try {
            await addProduct(buildWithoutDeal(product, pendingQuantity));
            toast.success(`${product.name} añadido al carrito (${pendingQuantity} ud.)`);
            try {
                await fulfillPendingOrder(product.code, actingAsCliente?.numCliente);
            } catch (error) {
                console.error('Failed to fulfill pending order after adding to cart:', error);
            }
            onAdded?.(product.code);
        } catch (error) {
            console.error('Failed to add restocked product to cart:', error);
            toast.error('No se pudo añadir al carrito. Puede que se haya agotado el stock.');
            onFailed?.();
        } finally {
            setLoading(false);
        }
    };

    return (
        <button type="button"
            className="btn btn-primary d-flex align-items-center justify-content-center gap-1 w-100"
            onClick={handleClick}
            disabled={loading}>
            {loading ? <CircularProgress size={20}/> : <AddShoppingCart/>}
            Añadir al carrito
        </button>
    );
};
